import { useState, useEffect } from "react";

export const useImpersonationReturnPath = () => {
  const [impersonationReturnPath, setImpersonationReturnPath] = useState<
    string | null
  >(() => {
    const stored = sessionStorage.getItem("impersonationReturnPath");
    return stored ? JSON.parse(stored) : null;
  });

  useEffect(() => {
    if (impersonationReturnPath !== null) {
      sessionStorage.setItem(
        "impersonationReturnPath",
        JSON.stringify(impersonationReturnPath),
      );
    } else {
      sessionStorage.removeItem("impersonationReturnPath");
    }
  }, [impersonationReturnPath]);

  return [impersonationReturnPath, setImpersonationReturnPath] as const;
};
